import { render, staticRenderFns } from "./DeleteReport.vue?vue&type=template&id=301964b4&"
import script from "./DeleteReport.vue?vue&type=script&lang=ts&"
export * from "./DeleteReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports